import {
  NavButtonsSidebarSkeleton,
  NavSidebarButton,
  NavSidebarSection,
  NavSidebarStatusButton,
} from '@insurancemenu/imenu-components-lib';
import { AssignmentInd } from '@insurancemenu/imenu-components-lib/dist/icons';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { SidebarDelegate } from 'store/flows/enrollment/sidebarDelegate';
import { RouteV2Id } from 'routes/routesConfigV2';
import { GROUP_PROFILE_BTN_TEST_ID } from 'components/common/enrollment/constants';
import InviteEmployerSection from 'components/common/group/InviteEmployerSection';
import { redirectToRoute } from 'routes/redirectToRoute';
import { CHECKLIST_STEPS_SECTION_TEST_ID, CHECKLIST_STEPS_SKELETON_TEST_ID } from '../../constants';

interface EnrollmentSidebarProps {
  sidebarDelegate: SidebarDelegate;
}

const EnrollmentSidebar: React.FC<EnrollmentSidebarProps> = observer(({ sidebarDelegate }) => {
  const { groupId, checklistSteps, isFlowDataLoading } = sidebarDelegate;

  const onRedirectClick = (): void => {
    redirectToRoute(RouteV2Id.GROUP_HUB, { groupId });
  };

  return (
    <>
      <NavSidebarSection label="Group">
        <NavSidebarButton
          leftIconProp={AssignmentInd}
          onClick={onRedirectClick}
          data-test-id={GROUP_PROFILE_BTN_TEST_ID}
        >
          Group Profile
        </NavSidebarButton>
        <InviteEmployerSection inviteEmployersDelegate={sidebarDelegate.inviteEmployersDelegate} />
      </NavSidebarSection>
      {isFlowDataLoading ? (
        <NavButtonsSidebarSkeleton data-test-id={CHECKLIST_STEPS_SKELETON_TEST_ID} />
      ) : (
        <NavSidebarSection label="Checklist Steps" data-test-id={CHECKLIST_STEPS_SECTION_TEST_ID}>
          {checklistSteps.map((step) => (
            <NavSidebarStatusButton
              key={step.pageId}
              completionStatus={step.completionStatus}
              // @ts-expect-error TO_DO: Replace with real pageId
              // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
              isActive={step.pageId === 'FORMS'}
              onClick={() => {
                // @ts-expect-error TO_DO: Replace with real pageId
                // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
                if (step.pageId !== 'FORMS') {
                  step.onClick();
                }
              }}
            >
              {step.label}
            </NavSidebarStatusButton>
          ))}
        </NavSidebarSection>
      )}
    </>
  );
});

export default EnrollmentSidebar;
